"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.container = void 0;

var react_1 = require("@emotion/react");

var typeStyles = {
  default: react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    &:hover {\n      background-color: #f5fbff;\n    }\n    &:focus {\n      color: #1583db;\n      background-color: #e7f4fd;\n    }\n    &:disabled {\n      color: #ced4da;\n      background-color: transparent;\n    }\n  "]))),
  minimized: react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    &:hover {\n      color: #1583db;\n    }\n    &:focus {\n      color: #0a70c2;\n    }\n    &:disabled {\n      color: #ced4da;\n    }\n  "])))
};
var sizeStyles = {
  large: react_1.css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    height: 32px;\n    font-size: 16px;\n    padding: 0px 8px;\n  "]))),
  medium: react_1.css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    height: 28px;\n    font-size: 14px;\n    padding: 0px 6px;\n  "])))
};

var container = function container(size, minimized) {
  return react_1.css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  height: ", ";\n  flex-direction: row;\n  align-items: center;\n  flex: 0 0 auto;\n  color: #2b96ed;\n  background-color: transparent;\n  outline: none;\n  font-weight: bold;\n  border-radius: 4px;\n  border: 0;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  ", "\n  ", "\n  ", ";\n"])), minimized ? 'min-content !important' : 'auto', sizeStyles[size], typeStyles[minimized ? 'minimized' : 'default'], minimized && 'padding: 0px 0px');
};

exports.container = container;